import axios from 'axios';
import toast from 'react-hot-toast';

/**
 * CRA only exposes env vars prefixed with REACT_APP_.
 * Set REACT_APP_API_URL on Vercel to your Render host, e.g. https://your-api.onrender.com (with or without /api).
 *
 * baseURL ends with /api — paths are relative to that, e.g. post('/auth/register') → POST .../api/auth/register.
 * Aliases on the server: POST .../api/signup and POST .../api/login (same handlers).
 */
function resolveApiBaseUrl() {
  const raw = (process.env.REACT_APP_API_URL || process.env.REACT_APP_BACKEND_URL || '')
    .trim()
    .replace(/\/$/, '');
  if (!raw) return '/api';
  if (raw.endsWith('/api')) return raw;
  return `${raw}/api`;
}

const api = axios.create({
  baseURL: resolveApiBaseUrl(),
  timeout: 60000,
});

// Attach JWT token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('z2e_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    const status = err.response?.status;
    const url = err.config?.url || '';

    if (status === 401) {
      // Only redirect to login if the /auth/me check fails (token truly invalid)
      // Don't redirect for other protected routes — let them show their own error
      if (url.includes('/auth/me')) {
        localStorage.removeItem('z2e_token');
        delete api.defaults.headers.common['Authorization'];
        if (window.location.pathname !== '/login') window.location.href = '/login';
      }
      // For other routes (premium, files, etc.) just reject — don't auto-logout
    } else if (status === 429) {
      toast.error('Too many requests, please slow down');
    } else if (status >= 500) {
      toast.error('Server error, please try again');
    }

    return Promise.reject(err);
  }
);

export default api;